function handleMenu() {
  $(".navbar-toggler").click(function () {
    let scrollPosition = 0;

    if (!$("body").hasClass("menu-open")) {
      scrollPosition = document.documentElement.scrollTop;
      $("html, body").animate({
        scrollTop: `${scrollPosition}px`,
      });
    }
    $("body").toggleClass("menu-open");
  });
}

export default handleMenu;
